import React from 'react';

/**
 * AmbientBackground — atmosphère premium « aurore dorée + grain ».
 *
 * Trois halos dorés/ambrés qui dérivent très lentement en profondeur (50–90 s),
 * surmontés d'un grain fin éditorial. Posé en z-index 0, derrière le contenu du
 * shell (qui est en z-10 ; le <main> est transparent), sans interaction (pointer-events: none), et
 * theme-aware via le CSS. Le mouvement se fige sous prefers-reduced-motion.
 *
 * Monté une fois dans le shell (AppLayout / PortalLayout).
 */
export default function AmbientBackground() {
  return (
    <div aria-hidden className="ambient-root">
      <div className="ambient-aurora ambient-aurora-1" />
      <div className="ambient-aurora ambient-aurora-2" />
      <div className="ambient-aurora ambient-aurora-3" />
      <div className="ambient-grain" />
    </div>
  );
}
